import axios from "axios"

const FicheroService = {
  descargarFichero(fileID: $TSMigrationFixMe) {
    return axios.get(`/Fichero/${fileID}/file`, {
      responseType: "blob",
    })
  },
}

export default FicheroService
